import { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import Switch from "@material-ui/core/Switch";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useNavigate, useLocation } from "react-router-dom";
import { EditPlayerDetails } from "../../../../api/AuthenticationServices";
const EditPlayer = (props) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const location = useLocation();

  const navigate = useNavigate();
  const playerDetails = location.state?.playerRow;
  // console.log("Player Data", playerDetails);
  const [isOn, setIsOn] = useState(false);

  const handleSwitchChange = (event) => {
    setIsOn(event.target.checked);
  };
  const initialValues = {
    plFirstName: playerDetails[0].firstname,
    plLastName: playerDetails[0].lastname,
    plDob: playerDetails[0].dateOfBirth,
    plGender: playerDetails[0].gender,
    plAddress: playerDetails[0].address,
    plFatherName: playerDetails[0].fatherName,
    plMotherName: playerDetails[0].motherName,
    plfatherPhnNumber: playerDetails[0].fatherPhnNumber,
    plmotherPhnNumber: playerDetails[0].motherPhnNumber,
    plParentOfficeAddress: playerDetails[0].officeAddress,
    plSchoolName: playerDetails[0].schoolName,
    plSchoolAddress: playerDetails[0].schoolAddress,
    plClassStudy: playerDetails[0].classStudy,
    plEmailId: playerDetails[0].email,
    plDateOfJoining: playerDetails[0].dateOfJoin,
    plTransportMode: playerDetails[0].transportMode,
    plAadhaar: playerDetails[0].aadhaar,
  };

  const sendData = async (e, values) => {
    console.log(values);
    e.preventDefault();
    const data = {
      plFirstName: values.plFirstName,
      plLastName: values.plLastName,
      plDob: values.plDob,
      plId: playerDetails[0].id,
      plGender: values.plGender,
      plAddress: values.plAddress,
      plFatherName: values.plFatherName,
      plMotherName: values.plMotherName,
      plfatherPhnNumber: values.plfatherPhnNumber,
      plmotherPhnNumber: values.plmotherPhnNumber,
      plParentOfficeAddress: values.plParentOfficeAddress,
      plSchoolName: values.plSchoolName,
      plSchoolAddress: values.plSchoolAddress,
      plClassStudy: values.plClassStudy,
      plEmailId: values.plEmailId,
      plDateOfJoining: values.plDateOfJoining,
      plTransportMode: values.plTransportMode,
      plAadhaar: values.plAadhaar,
      plActive: isOn,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
      },
    };
    // console.log("DAta Player : ", data);
    // console.log("Before AddNew Plafer");
    try {
      const res = await EditPlayerDetails(data, config);

      if (res.data.status === "success") {
        // console.log("Inside Successs");
        alert(res.data.message);
        navigate("/admin/viewplayers");
      } else {
        if (res.data.status === "") {
          alert(res.data.message);
          navigate("/admin/viewplayers");
        }
      }
    } catch (e) {
      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
      navigate("/admin/viewplayers");
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header title="EDIT PLAYER DETAILS" subtitle="Edit player" />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            // console.log(values,handleChange)
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plFirstName}
                  name="plFirstName"
                  error={!!touched.plFirstName && !!errors.plFirstName}
                  helperText={touched.plFirstName && errors.plFirstName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plLastName}
                  name="plLastName"
                  error={!!touched.plLastName && !!errors.plLastName}
                  helperText={touched.plLastName && errors.plLastName}
                  sx={{ gridColumn: "span 2" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="Date of Birth"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plDob}
                  name="plDob"
                  error={!!touched.plDob && !!errors.plDob}
                  helperText={touched.plDob && errors.plDob}
                  sx={{ gridColumn: "span 4" }}
                />
                <InputLabel id="pl-gen" sx={{ gridColumn: "span 2" }}>
                  Select Gender
                </InputLabel>
                <Select
                  labelId="pl-gen"
                  fullWidth
                  variant="filled"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plGender}
                  name="plGender"
                  error={!!touched.plGender && !!errors.plGender}
                  helperText={touched.plGender && errors.plGender}
                  sx={{ gridColumn: "span 2" }}
                >
                  <MenuItem value="" disabled>
                    <em>Player Gender</em>
                  </MenuItem>
                  <MenuItem value="Male">Male</MenuItem>
                  <MenuItem value="Female">Female</MenuItem>
                </Select>
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Player Email Id"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plEmailId}
                  name="plEmailId"
                  error={!!touched.plEmailId && !!errors.plEmailId}
                  helperText={touched.plEmailId && errors.plEmailId}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plAddress}
                  name="plAddress"
                  error={!!touched.plAddress && !!errors.plAddress}
                  helperText={touched.plAddress && errors.plAddress}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Father Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plFatherName}
                  name="plFatherName"
                  error={!!touched.plFatherName && !!errors.plFatherName}
                  helperText={touched.plFatherName && errors.plFatherName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Mother Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plMotherName}
                  name="plMotherName"
                  error={!!touched.plMotherName && !!errors.plMotherName}
                  helperText={touched.plMotherName && errors.plMotherName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Father Contact Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plfatherPhnNumber}
                  name="plfatherPhnNumber"
                  error={
                    !!touched.plfatherPhnNumber && !!errors.plfatherPhnNumber
                  }
                  helperText={
                    touched.plfatherPhnNumber && errors.plfatherPhnNumber
                  }
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Mother Contact Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plmotherPhnNumber}
                  name="plmotherPhnNumber"
                  error={
                    !!touched.plmotherPhnNumber && !!errors.plmotherPhnNumber
                  }
                  helperText={
                    touched.plmotherPhnNumber && errors.plmotherPhnNumber
                  }
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Aadhaar Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plAadhaar}
                  name="plAadhaar"
                  error={!!touched.plAadhaar && !!errors.plAadhaar}
                  helperText={touched.plAadhaar && errors.plAadhaar}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Office Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plParentOfficeAddress}
                  name="plParentOfficeAddress"
                  error={
                    !!touched.plParentOfficeAddress &&
                    !!errors.plParentOfficeAddress
                  }
                  helperText={
                    touched.plParentOfficeAddress &&
                    errors.plParentOfficeAddress
                  }
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="School Name"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plSchoolName}
                  name="plSchoolName"
                  error={!!touched.plSchoolName && !!errors.plSchoolName}
                  helperText={touched.plSchoolName && errors.plSchoolName}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="School Address"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plSchoolAddress}
                  name="plSchoolAddress"
                  error={!!touched.plSchoolAddress && !!errors.plSchoolAddress}
                  helperText={touched.plSchoolAddress && errors.plSchoolAddress}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Class Currently Studying"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plClassStudy}
                  name="plClassStudy"
                  error={!!touched.plClassStudy && !!errors.plClassStudy}
                  helperText={touched.plClassStudy && errors.plClassStudy}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="Date of Joining"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plDateOfJoining}
                  name="plDateOfJoining"
                  error={!!touched.plDateOfJoining && !!errors.plDateOfJoining}
                  helperText={touched.plDateOfJoining && errors.plDateOfJoining}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Mode of Transport"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plTransportMode}
                  name="plTransportMode"
                  error={!!touched.plTransportMode && !!errors.plTransportMode}
                  helperText={touched.plTransportMode && errors.plTransportMode}
                  sx={{ gridColumn: "span 4" }}
                />
                <InputLabel id="pl-gen" sx={{ gridColumn: "span 2" }}>
                  Active / Not Active
                </InputLabel>
                <Switch
                  checked={isOn}
                  onChange={handleSwitchChange}
                  sx={{ gridColumn: "span 4" }}
                />
                <span>{isOn ? "true" : "false"}</span>

                {/* <InputLabel id="pl-siblings" sx={{ gridColumn: "span 2" }}>
                  Select If any Siblings
                </InputLabel>
                <Select
                  labelId="pl-siblings"
                  fullWidth
                  variant="filled"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.plSiblings}
                  name="plSiblings"
                  error={!!touched.plSiblings && !!errors.plSiblings}
                  helperText={touched.plSiblings && errors.plSiblings}
                  sx={{ gridColumn: "span 2" }}
                >
                  <MenuItem value="" disabled>
                    <em>Player Siblings</em>
                  </MenuItem>
                  {mockSiblings.map(
                    function (sib, index) {
                      return (
                        <MenuItem key={index} value={sib.id}>
                          {sib.name}
                        </MenuItem>
                      );
                    },
                    [1]
                  )}
                </Select> */}
              </Box>
              {/* <button type="submit">asdasd</button> */}
              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  disabled={false}
                  color="secondary"
                  variant="contained"
                >
                  Update Player
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const phoneRegExp =
  /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;

const checkoutSchema = yup.object().shape({
  plFirstName: yup.string().required("required"),
  plLastName: yup.string().required("required"),
  plDob: yup.string().required("required"),

  plGender: yup.string().required("required"),
  plemail: yup.string().email("invalid email").required("required"),
  plAddress: yup.string().required("required"),
  plFatherName: yup.string().required("required"),
  plMotherName: yup.string().required("required"),
  plfatherPhnNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  plmotherPhnNumber: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  plParentOfficeAddress: yup.string().required("required"),
  plSchoolName: yup.string().required("required"),
  plSchoolAddress: yup.string().required("required"),
  plClassStudy: yup.string().required("required"),
  plTransportMode: yup.string().required("required"),
  plDateOfJoining: yup.string().required("required"),
});

export default EditPlayer;
